<template>
    <ds-status
        class="status-label"
        emphasis="high"
        :data-qa="`${broadcastSubject}-status`"
        :type="broadcastStatusType"
    >
        {{ broadcastStatusMessage }}
    </ds-status>
</template>

<script>
import {
    BROADCAST_STATUS,
    MESSAGE_CONSTANTS,
    STATUS_TYPE,
} from '@/components/broadcast/constants/emailBroadcast.constants.js';
import { STEPS } from '@/components/unlayer/constants/editor.constants';

export default {
    MESSAGE_CONSTANTS,

    props: {
        email: {
            type: Object,
            required: true,
        },
    },

    computed: {
        broadcastStatusMessage() {
            const status = (this.email.broadcastState || '').toUpperCase();

            return MESSAGE_CONSTANTS.STATUS_CHIP[status] || MESSAGE_CONSTANTS.STATUS_CHIP.Draft;
        },

        broadcastStatusType() {
            const status = (this.email.broadcastState || '').toUpperCase();
            const {
                CANCELLED,
                DONE,
                ERROR,
                PROCESSING,
                QUEUED,
                SCHEDULING,
            } = BROADCAST_STATUS;

            if ([SCHEDULING, QUEUED, PROCESSING, CANCELLED].includes(status)) {
                return STATUS_TYPE.WARNING;
            }

            if (status === DONE) {
                return STATUS_TYPE.GOOD;
            }

            if (status === ERROR) {
                return STATUS_TYPE.ERROR;
            }

            return STATUS_TYPE.DEFAULT;
        },

        broadcastSubject() {
            return this.email[STEPS.SUBJECT].subject || MESSAGE_CONSTANTS.NO_SUBJECT;
        },
    },
};
</script>
